export default {
  namespaced: true,

  state: () => {
    return {
      isOpen: false,
    }
  },

  mutations: {
    SET_IS_OPEN (state) {
      state.isOpen = true
    },

    SET_IS_CLOSED (state) {
      state.isOpen = false
    },
  },
}
